import React, { useState } from 'react';
import MessageTemplateForm from './MessageTemplateForm';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../helpers/AxiosAPI';
import { putAPI_Update_QuickReply } from '../../constants/APIs';
import PropTypes from 'prop-types';

export default function UpdateMessageTemplateForm({
  id,
  propertyId,
  loadQuickTemmplates,
}) {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleSubmit = (data) => {
    const formmatedData = { ...data, updater: 'admin' };

    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_QuickReply}/${id}`,
      data: formmatedData,
    }).then(() => {
      loadQuickTemmplates();
      setIsUpdating(!isUpdating);
    });
  };

  return (
    <div>
      <Button
        color="primary"
        size="xs"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      {isUpdating && (
        <MessageTemplateForm
          formLabel="Update the Template"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          propertyId={propertyId}
        />
      )}
    </div>
  );
}
